import { ErrorMessage, ErrorMessageWrapper } from "../../components/messages";
import { VirtualTable } from "../../components/tables";
import { TableRecordCountDisplayFooter } from "../../components/tables/VirtualTable";
import PersonalReminderTableRow from "./components/PersonalReminderTableRow";
import { usePersonalReminders } from "./hooks/PersonalRemindersContext";
import PersonalReminderTableHeader from "./components/PersonalReminderTableHeader";
import React from "react";
import EditPersonalReminderModal from "./components/EditPersonalReminderModal";

const PersonalReminders = () => {

    const {  clear: refreshTable,
            loadMore,
            isRowLoaded,
            sort,
            sortTable,
            results,
            totalCount,
            error,
            isNextPageLoading,
            isError, } = usePersonalReminders();

    if (isError) {
        return (
            <ErrorMessageWrapper>
                <ErrorMessage error={error} retryCallback={refreshTable} />
            </ErrorMessageWrapper>
        );
    }

    return (<React.Fragment>
        <VirtualTable
            enableScrollTracking={false}
            row={PersonalReminderTableRow}
            header={<PersonalReminderTableHeader />}
            footer={
                <TableRecordCountDisplayFooter 
                    totalCount={totalCount}
                    isNewRecordsDisplayed={false}
                    newRecordsSinceCache={0}
                    reload={refreshTable}
                    spanRight={6}
                />
            }
            error={error}
            isLoading={isNextPageLoading}
            isItemLoaded={isRowLoaded}
            loadMoreItems={loadMore}
            itemSize={42}
            itemCount={totalCount}
            itemData={results}
        />
        <EditPersonalReminderModal />
    </React.Fragment>
    );
};

export default PersonalReminders;